export { default } from "./LabeledItem";
